import React from 'react';
import styled from 'styled-components';
import Text from 'components/Text';

const ModalBackdrop = styled.div`
  // Basic modal styling
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 3;
`;

const ModalMain = styled.div`
  // Basic modal styling
  position: fixed;
  background: white;
  height: auto;
  width: 400px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  // Styling for Kitu
  display: inline-block;
  border-radius: 4px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.12);
  padding: 24px;
`;

export const ModalHeader = styled(Text)`
  font-size: 16px;
  font-weight: 500;
  padding-bottom: ${({ paddingBottom }) => paddingBottom || '12px'};
  padding-right: 100px;
  max-width: 550px;
  color: #2a2a2a;

  &:first-of-type {
    padding-top: 8px;
  }
`;

export const ModalMessage = styled(Text)`
  font-size: 16px;
  max-width: 550px;
  padding: 0.75em 0;
  padding-bottom: 2em;
  font-weight: 500;
  color: #4a4a4a;
`;

const Modal = ({ children, ...props }) => {
  return (
    <ModalBackdrop>
      <ModalMain {...props}>{children}</ModalMain>
    </ModalBackdrop>
  );
};

export default Modal;
